/*
 * @Author: Liyafei
 * @Date: 2023-04-14 11:19:47
 * @Description:
 */
import request from '@/utils/request';

// export function getCosToken(data, source) {
//   return request({
//     url: '/adminapi/file/token',
//     method: 'get',
//     cancelToken: source?.token || '',
//     params: data
//   });
// }

// minio获取上传链接
export function postFilePresignedUrl(data) {
  return request({
    url: '/adminapi/file/presignedUrl',
    method: 'post',
    data
  });
}

// minio上传文件
export function putMinioFile(
  baseURL,
  url,
  data,
  contentType,
  cancelToken = null,
  onUploadProgress = () => {}
) {
  return request({
    baseURL: baseURL,
    headers: {
      'Content-Type': contentType
    },
    requestType: 's3',
    url: url,
    method: 'PUT',
    data: data,
    cancelToken: cancelToken,
    onUploadProgress: onUploadProgress
  });
}

// export function getNewCosToken(data, source) {
//   return request({
//     url: '/adminapi/file/upload-token',
//     method: 'get',
//     cancelToken: source?.token || '',
//     params: data
//   });
// }

export function getUpdateToken(data, source) {
  return request({
    url: '/adminapi/file/session',
    method: 'get',
    cancelToken: source?.token || '',
    params: data
  });
}
export function asyncExport(url, method, data = {}) {
  return request({
    url: url,
    method: method,
    ...data
  });
}

export function getStructureEnterpriseV2(data) {
  return request({
    url: '/adminapi/structure/v2/tree',
    method: 'get',
    params: data
  });
}

export function getStructureUsersV2(data) {
  return request({
    url: '/adminapi/structure/v2/search',
    method: 'get',
    params: data
  });
}

// 组织架构，搜索人员(离职+在职)
export function getStructureUsersAll(data) {
  return request({
    url: '/adminapi/structure/search/all',
    method: 'get',
    params: data
  });
}

// 自定义上传接口
export function getUpload(
  url,
  data = {},
  method = 'get',
  msgReplaceData = false
) {
  return request({
    url: url,
    method: method,
    ...data,
    msgReplaceData: msgReplaceData
  });
}

// 包含外部租户组织架构
export function getStructureV2EnterpriseOutside(data) {
  return request({
    url: '/a/enterprise/outside',
    method: 'get',
    params: data
  });
}

// 刷新session，防止上传资源过长，session失效
export function getFileSession() {
  return request({
    url: '/adminapi/file/session',
    method: 'get'
  });
}

// 审批中的人员列表
export function getAuditingUsers(data) {
  return request({
    url: '/adminapi/approval/process/auditing/users',
    method: 'get',
    params: data
  });
}
//指定审核人的岗位列表
export function getAuditorDepts(data) {
  return request({
    url: '/adminapi/approval/process/auditor/depts',
    method: 'get',
    params: data
  });
}
// 获取系统准确时间
export function getSysytemTime() {
  return request({
    method: 'get',
    url: '/adminapi/system/time'
  });
}

//所有审批类型
export function getCategorys() {
  return request({
    method: 'get',
    url: '/adminapi/approval/category/selection'
  });
}
//搜索组织架构,岗位名称模糊检索
export function getStructureV2SearchKeyWord(data) {
  return request({
    url: '/adminapi/structure/v2/search/keyWord',
    method: 'get',
    params: data
  });
}
//日志记录
export function getBiLogLog(data) {
  return request({
    url: '/adminapi/bi/log/log',
    method: 'get',
    params: data
  });
}
export function getEnterpriseConfig(data) {
  return request({
    url: '/adminapi/enterprise/config/get',
    method: 'get',
    params: data
  });
}
